const _template = require('lodash.template'); // eslint-disable-line no-underscore-dangle

/**
 * Creates DOM from a ES6 template using lodash @see{@link https://lodash.com/docs#template}
 * @param template
 * @param params
 * @returns {Node}
 */
function create(template, params) {

  if (!template || template === '') {
    throw new Error('Template Cannot Be Null or Empty');
  }

  const compiled = _template(template);

  const element = document.createElement('DIV');
  element.innerHTML = compiled(params);
  return element.firstChild;
}

module.exports = { create: create };
